import {AbstractNegotiationCloser} from "@/modules/diplomacy/services/AbstractNegotiationCloser";
import {inject, injectable} from "inversify";
import {StaffNegotiation} from "@/modules/staff/entity";
import {StaffMemberTransferator} from "@/modules/staff/services/StaffMemberTransferator";
import {Team} from "@/modules/team/entity";
import {NegotiationCloserInterface} from "@/modules/diplomacy/interfaces";
import {Negotiation} from "@/modules/diplomacy/entity";

@injectable()
export class StaffNegotiationCloser extends AbstractNegotiationCloser implements NegotiationCloserInterface {
  constructor(
    @inject(StaffMemberTransferator) private staffMemberTransferator: StaffMemberTransferator,
  ) {
    super();
  }

  async shouldRun(negotiation: Negotiation) {
    return negotiation instanceof StaffNegotiation;
  }

  async can(negotiation: StaffNegotiation) {
    const team = await Team
      .createQueryBuilder('team')
      .leftJoinAndSelect('team.staffMembers', 'staffMember')
      .where('team.user = true')
      .getOneOrFail();

    return this.staffMemberTransferator.canTransfer(negotiation.target, team);
  }

  async close(negotiation: StaffNegotiation): Promise<void> {
    const team = await Team
      .createQueryBuilder('team')
      .leftJoinAndSelect('team.staffMembers', 'staffMember')
      .where('team.user = true')
      .getOneOrFail();

    await this.staffMemberTransferator.transfer(negotiation.target, team, negotiation.once);
    await this.endAllOtherNegotiations(negotiation);
    await super.close(negotiation);
  }
}